<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :title="'图片预览'"
    width="70%"
    :close-on-click-modal="true"
    :close-on-press-escape="true"
    :show-close="true"
    :before-close="closePreview"
    custom-class="image-preview-dialog"
    top="10vh"
    :modal-append-to-body="false"
    :append-to-body="true"
    :z-index="9999"
  >
    <div class="image-preview-body">
      <img 
        :src="imageSrc" 
        :alt="imageAlt" 
        class="image-preview-img"
        @load="onImageLoad"
        @error="onImageError"
      />
      <div v-if="loading" class="image-preview-loading">
        <div class="loading-spinner"></div>
        <span>加载中...</span>
      </div>
      <div v-if="error" class="image-preview-error">
        <span>图片加载失败</span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ImagePreview',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    imageSrc: {
      type: String,
      default: ''
    },
    imageAlt: {
      type: String,
      default: '图片'
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      }
    }
  },
  data() {
    return {
      loading: true,
      error: false
    }
  },
  watch: {
    imageSrc: {
      handler(newVal) {
        if (newVal) {
          this.loading = true;
          this.error = false;
        }
      },
      immediate: true
    }
  },
  methods: {
    closePreview() {
      this.$emit('close');
    },
    onImageLoad() {
      this.loading = false;
      this.error = false;
    },
    onImageError() {
      this.loading = false;
      this.error = true;
    }
  }
}
</script>

<style scoped lang="scss">
.image-preview-body {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  padding: 10px;
  overflow: hidden;
}

.image-preview-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 4px;
  min-width: 50%;
  min-height: 80%;
}

.image-preview-loading,
.image-preview-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #86909c;
  font-size: 16px;
}

.loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e5e6eb;
  border-top: 3px solid #007aff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 12px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>

<style lang="scss">
// 全局样式，用于自定义dialog样式
.image-preview-dialog {
  .el-dialog__body {
    padding: 0;
    text-align: center;
    max-height: 70vh;
    overflow: auto;
  }
  
  .el-dialog__header {
    padding: 15px 20px 10px;
    border-bottom: 1px solid #e5e6eb;
    background: #f8f9fa;
    
    .el-dialog__title {
      font-size: 16px;
      font-weight: 500;
      color: #1d2129;
    }
  }
  
  .el-dialog__headerbtn {
    top: 15px;
    right: 20px;
    
    .el-dialog__close {
      font-size: 18px;
      color: #86909c;
      
      &:hover {
        color: #1d2129;
      }
    }
  }
}
</style>
